import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import useCSRFToken from 'hooks/use-csrf-token';

import client from '../client';

import type { Response } from '../types';

type UseUnblockFreelancerInLocationInput = {
  locationId: number;
  userId: number;
};

const useUnblockFreelancerInLocation = (): UseMutationResult<
  Response,
  string,
  UseUnblockFreelancerInLocationInput,
  unknown
> => {
  const csrfToken = useCSRFToken();
  const mutation = useMutation<
    Response,
    string,
    UseUnblockFreelancerInLocationInput,
    unknown
  >(
    'unblock-freelancer-in-location',
    async (params: UseUnblockFreelancerInLocationInput) => {
      const response = await fetch(
        `/api/location/${params.locationId}/blocked/user/${params.userId}/`,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
          },
          method: 'DELETE',
        },
      );

      if (response.ok) return response.json();
      throw new Error('Something went wrong');
    },
    {
      onSuccess: () => {
        const queriesToInvalidate = [
          'organization-jobs',
          'paginated-organization-jobs',
          'job-details',
        ];
        queriesToInvalidate.forEach((query) => {
          client.invalidateQueries(query);
        });
      },
    },
  );

  return mutation;
};

export default useUnblockFreelancerInLocation;
